module.exports = __webpack_public_path__ + "static/assets/195b65444703293e0624ff4e09c13c81.png";